import { useStreakCompletionResultStore } from '../stores/streak_completion_result_store';
export const useStreakCompletionResult = () => {
    const streakCompletionResult = useStreakCompletionResultStore((state) => state.streakCompletionResult);
    const setStreakCompletionResult = useStreakCompletionResultStore((state) => state.setStreakCompletionResult);
    const resetStreakCompletionResult = useStreakCompletionResultStore((state) => state.resetStreakCompletionResult);
    return { streakCompletionResult, setStreakCompletionResult, resetStreakCompletionResult };
};
